"use strict";

var _taggedTemplateLiteral = require("/home/circleci/poc-carditas-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  animation: ", " 2s linear infinite;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n100% {\n  transform:rotate(360deg);\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spin = void 0;

var _core = require("@emotion/core");

var spinKeyframes = (0, _core.keyframes)(_templateObject());

var spin = function spin() {
  return (0, _core.css)(_templateObject2(), spinKeyframes);
};

exports.spin = spin;